import { StatusCodes } from 'http-status-codes';

export const ERROR_STATUS_CODES_FOR_LOGOUT = [
  StatusCodes.UNAUTHORIZED,
  StatusCodes.GONE
];
